import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const oidcSliceName = "oidc";

export interface OidcState {
  userData: UserData | null;
}

export interface UserInfo {
  ["avengers:assigned_roles"]?: string | null;
  ["avengers:user_id"]?: string | null;
  ["avengers:kira_id"]?: string | null;
  ["custom:corporation"]?: string | null;
  ["custom:sub_department_no"]?: string | null;
  ["email"]?: string | null;
  ["family_name"]?: string | null;
  ["given_name"]?: string | null;
  ["locale"]?: string | null;
  ["name"]?: string | null;
}

export interface UserData {
  userInfo: UserInfo;
  idToken: string;
  accessToken: string;
}

const initialState: OidcState = {
  userData: null,
};

const oidcSlice = createSlice({
  name: oidcSliceName,
  initialState,
  reducers: {
    setUserData(state: OidcState, action: PayloadAction<UserData | null>) {
      state.userData = action.payload;
    },
  },
});

export interface OidcRootState {
  [oidcSliceName]: OidcState;
}

export const selectOidc = (state: OidcRootState) => state[oidcSliceName];
export const selectOidcUserData = (state: OidcRootState) => {
  const oidcState: OidcState = state[oidcSliceName];
  if (oidcState.userData === null) {
    throw Error("OIDC UserData is not available!");
  }

  return oidcState.userData;
};

export const { setUserData } = oidcSlice.actions;
export const oidcReducer = oidcSlice.reducer;
